import { DeepReadonly } from '../types/DeepReadonly';
import { NavItemType } from '../types/menu';
import { FormattedMessage } from 'react-intl';
import { useMemo } from 'react';

export const usePersonalMenuItems = (): DeepReadonly<NavItemType>[] =>
	useMemo(
		() => [
			{
				id: 'my-account',
				title: <FormattedMessage id={'menu.account'} />,
				type: 'item',
				url: '/settings/my-account',
				isActive: (location) => location.pathname.startsWith('/settings/my-account'),
			},
			{
				id: 'my-notifications',
				title: <FormattedMessage id={'menu.notifications'} />,
				type: 'item',
				url: '/settings/my-notifications',
				isActive: (location) => location.pathname.startsWith('/settings/my-notifications'),
			},
			{
				id: 'my-language-and-region',
				title: <FormattedMessage id={'menu.language-and-region'} />,
				type: 'item',
				url: '/settings/my-language-and-region',
				isActive: (location) => location.pathname.startsWith('/settings/my-language-and-region'),
			},
		],
		[],
	);
